import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Wrapper = styled.div`
  max-width: 794px;
  text-align: center;
  padding: 50px 0;

  ${({ theme }) => theme.media.tablet} {
    max-width: inherit;
  }

  ${({ theme }) => theme.media.mobile} {
    max-width: inherit;
    padding: 44px 0 60px;
  }
`;

export const Heading = styled.h2`
  margin-bottom: 15px;
  color: ${({ theme }) => theme.colors.gray700};
  text-align: center;
  ${getFontStyle('bold120_B2')};
`;

export const ArrowIconWrapper = styled.span`
  display: inline-flex;
  margin-left: 6px;
`;
